import { Component, Injector } from '@angular/core';
import type { OnDestroy, OnInit } from '@angular/core';
import type { ModalOptions } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// import { PopoverController } from '@ionic/angular';
import { timer } from 'rxjs';

import { RadioModalPage } from '@shared/pages';
import {
    CampaignIncentiveSetsService, CampaignsService, CustomersService, SummaryService
} from '@shared/services';
import { CustomerMessagesBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TCampaign, TCustomer, TSetting, TCampaignIncentiveSet } from '@shared/models';

@Component({
    'selector': 'app-campaign',
    'templateUrl': './campaign.page.html',
    'styleUrls': ['./campaign.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
// export class CampaignPage extends ViewBasePage implements OnInit, OnDestroy {
export class CampaignPage extends CustomerMessagesBasePage implements OnInit, OnDestroy {
    private settings: Partial<TSetting> = {};
    private incentiveSets: TCampaignIncentiveSet[];
    public selectedIncentiveSet: TCampaignIncentiveSet;
    private incentiveSetSelectables;
    public numCustomers: number;
    public numActiveCustomers = 0;
    public selectedCustomers: TCustomer[] = [];

    constructor(private customersService: CustomersService, private campaignsService: CampaignsService,
        private campaignIncentiveSetsService: CampaignIncentiveSetsService,
        private summaryService: SummaryService,  injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(Constants.VIEW_CAMPAIGN);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        try {
            const settings = await this.settingsService.get();
            this.settings = settings || {};
        } catch (err) {
            this.settings = {};
        }
        this.selectedCustomers = await this.customersService.getAll();
        
        // const summary = await this.summaryService.getByUid('overallSummary');
        const summary = await this.summaryService.getOverallSummary();
        this.numCustomers = summary.numCustomers ?? 0;
        this.incentiveSets = await this.campaignIncentiveSetsService.getAll();

        if (this.isDisabled()) {
            const msg = `The 'Sending Campaigns' feature has been disabled. Upgrade now to unlock this feature.`;
            this.uxHelperService.showAlert('Information', msg);
        }
        this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
        // this.customersSubscription.unsubscribe();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Send Campaign To Me');
        // this.pushPopoverMenuItem('Show Tour', 'show-campaigns-tour');

        this.moreMenuItemClick((menuItem: any) => {
            switch (menuItem.name) {
                case 'Send Campaign To Me':
                    this.sendCampaignToMe();
                    break;
            }
        });
    }

    public isDisabled() {
        const disable = (this.vb.disabled ||
            this.sessionService.getAccountProfile().featuresInfo.campaign === false ||
            this.settings?.campaignMessage?.enabled === false);
        return disable;
    }


    // private async openCheckboxModal(selectables  /*, items */) {
    //     const options: ModalOptions = {
    //         'component': CheckboxModalPage,
    //         'componentProps': {
    //             'selectables': selectables,
    //             // 'items': items, 
    //             'title': 'Select Customers',
    //             'showTestCustomerButton': false
    //         },
    //         'backdropDismiss': true,
    //         'showBackdrop': true,
    //         'cssClass': 'myModalSize'
    //     };

    //     const myModal = await this.modalController.create(options);
    //     myModal.onDidDismiss()
    //         .then((response: any) => {
    //             if (response.data.okay) {
    //                 this.selectedCustomers = response.data.selectedItems;
    //             }
    //         });

    //     myModal.present();
    // }

    public async onIncentiveSetPrompt(): Promise<void> {
        const setNames = this.incentiveSets.map(item => item.setName);

        const options: ModalOptions = {
            'component': RadioModalPage,
            'componentProps': { 'items': setNames, 'title': 'Select Incentive Set' },
            'backdropDismiss': false,
            'showBackdrop': true,
            'cssClass': 'campaignRadioModal'
        };

        const myModal = await this.modalController.create(options);
        await myModal.present();
        const response = await myModal.onDidDismiss();
        if (response.data?.okay) {
            const selectedIncentive = this.incentiveSets.find(incentive => (incentive.setName === response.data.selectedItem));
            if (selectedIncentive) {
                this.selectedIncentiveSet = selectedIncentive;
            }
        }
    }

    public isInvalidIncentiveSetName(): boolean {
        if (!this.selectedIncentiveSet) {
            return true;
        }

        return this.utilsService.isBlank(this.selectedIncentiveSet.setName);
    }

    private async sendCampaignToMe() {
        try {
            const user = this.sessionService.getCurrentUser();
            if (user.role !== 'manager') {
                throw new Error('Only managers can send campaigns.');
            }

            this.selectedCustomers = this.formatUsersAsCustomers([user]);
            this.sendCampaign();
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Warning', errorMessage);
        }
    }

    // Moved to CustomerMessagesBase
    // private formatUsersAsCustomers(users: TUser[]): TCustomer[] {
    //     const selectables = [];

    //     users.forEach((user: TUser) => {
    //         selectables.push({
    //             'line1': user.firstName + ' ' + user.lastName,
    //             'line2': this.utilsService.maskPhoneNumber(user.cellPhone),
    //             'customerName': user.firstName + ' ' + user.lastName,
    //             'cellPhone': user.cellPhone,
    //             'disabled': false,
    //             'isActive': true,
    //             'shuttleDates': [Date.now()],
    //             'uid': user.uid,
    //             'isCustomer': false
    //         });
    //     });
    //     return selectables;
    // }

    public async onSendCampaignClick() {
        // const title = 'Confirm Sending Campaign';
        // // const message = `Do you really want to send the campaign to ${this.selectedCustomers.length} customers?`;
        // const message = `Do you really want to send the campaign to ${this.numCustomers} customers?`;
        // this.uxHelperService.showConfirmationAlert(title, message, async (response) => {
        //     if (response.selection) {
        //         this.sendCampaign();
        //     }
        // });
        this.sendCampaign();
    }

    private async sendCampaign() {
        try {
            this.uxHelperService.showToast(`Sending Campaign Now...`);

            // https://javascript.plainenglish.io/async-await-foreach-81d4859f2b8c
            for (const customer of this.selectedCustomers) {
                const data = { 'customers': [customer], 'incentiveSet': this.selectedIncentiveSet };
                timer(50);

                await this.smsService.sendCampaignMessage(data);
            }
            this.uxHelperService.showToast(`Finished Sending Campaign.`);

            const campaign: TCampaign = {
                'sentDate': this.dateService.now(),
                'numRecipients': this.selectedCustomers.length,
                'createdDate': this.dateService.getMinimumDate(),
                'message': '',
                'uid': ''
            };
            await this.campaignsService.add(campaign);
            this.router.navigateByUrl('/marketing/campaigns');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }

    public getNumSelectedCustomersStr(): string {
        const len = this.selectedCustomers.length;
        const str = this.utilsService.useSingularOrPlural(len, 'customer', 'customers');
        const text = `${str} selected`;
        return text;
    }
}
